import { useMemo, useState } from "react";
import Modal from "react-modal";
import {
  Container,
  TitleBlackUpload,
  ButtonContainerTop,
  ButtonOKUpload,
  GridTitle,
} from "../Modais/styles";
import api from "../../services/api/index";
import { useProgress } from "../../hooks/progress";
import { useAPI } from "../../hooks/contextApis";
import buttonXSvg from "../Images/ButtonX.svg";
import { InputFileMultiple } from "../Inputs/InputFileMultiple";
import { useToast } from "../../hooks/ToastContext";
import { IconButton } from "@mui/material";
import { ModalProgress } from "../GeradorDePropostas/ModalProgress";

// ----------------------------------------------------------------------

export function ModalUploadAttatchment({
  idCard,
  isOpen,
  onClose,
}: {
  idCard: string;
  isOpen: boolean;
  onClose: VoidFunction;
}) {
  const { showToast } = useToast();

  // ----------------------------------------------------------------------

  const { isLoad, setLoad } = useProgress();
  const { setDataUser } = useAPI();

  const refreshUserData = async () => {
    setLoad(true);
    await api
      .get(`/csp/cliente/consultar/card/` + idCard)
      .then((res) => setDataUser(res.data));
    setLoad(false);
    setProgressIndex(0);
    setAttachments([]);
    onClose();
  };

  // ----------------------------------------------------------------------

  const [progressIndex, setProgressIndex] = useState(0);
  const [attachments, setAttachments] = useState<File[]>([]);

  const lastIndex = useMemo(() => attachments.length, [attachments]);

  const handleAdd = async () => {
    setLoad(true);
    setProgressIndex(0);

    try {
      for (let i = 0; i < attachments.length; i++) {
        const arrayBuffer = await attachments[i].arrayBuffer();
        const extension = attachments[i].name.split(".").pop() || ".undefined";
        await api.post("/csp/fatura/salvar", arrayBuffer, {
          headers: {
            "Content-Type": attachments[i].type,
          },
          params: {
            idCard: idCard,
            nomeArquivo: `${idCard}-${new Date().getTime()}.${extension.toLowerCase()}`,
          },
        });
        setProgressIndex(i + 1);
      }

      setTimeout(() => {
        showToast("success", "Arquivos adicionados!");
        refreshUserData();
      }, 1500);
    } catch (error) {
      console.error(error);
      showToast("error", "Falha ao anexar arquivo");
      setLoad(false);
    }
  };

  // ----------------------------------------------------------------------

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: "modal-base-delete",
        afterOpen: "",
        beforeClose: "modal-base_before-close",
      }}
      overlayClassName={{
        base: "overlay-base",
        afterOpen: "overlay-base_after-open",
        beforeClose: "overlay-base_before-close",
      }}
      shouldCloseOnOverlayClick={true}
    >
      <Container>
        <GridTitle>
          <TitleBlackUpload>Adicionar anexos à proposta</TitleBlackUpload>
          <IconButton onClick={onClose}>
            <img src={buttonXSvg} width={15} height={15} alt={""} />
          </IconButton>
        </GridTitle>

        <br />

        <InputFileMultiple
          onChange={setAttachments}
          uploadedIndex={progressIndex}
        />

        <br />

        <ButtonContainerTop>
          <ButtonOKUpload
            onClick={handleAdd}
            disabled={isLoad || !attachments.length}
          >
            Adicionar
          </ButtonOKUpload>
        </ButtonContainerTop>
      </Container>

      <ModalProgress
        isOpen={isLoad}
        percent={Math.round(100 / lastIndex) * progressIndex}
      />
    </Modal>
  );
}
